module.exports = __webpack_public_path__ + "static/media/12-adresse.7e884751.mp3";